import React from 'react';
import { Box, Button, Checkbox, FormControlLabel, Grid } from '@mui/material';
import ConfirmModal from '../../../_common/Modal/ConfirmModal';
import { useState } from 'react';
import ArrowBackIosSharpIcon from '@mui/icons-material/ArrowBackIosSharp';
import { useTranslation } from 'react-i18next';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ConfirmPartsModal, { ConfirmParts } from './Modal/ConfirmPartsModal';

type PartsSelectionFooterProps = {
  isSelectableParts: boolean;
  partsList: ConfirmParts[];
  isShowOptionParts: boolean;
  setIsShowOptionParts: React.Dispatch<React.SetStateAction<boolean>>;
  onClickBack: () => void;
  onClickReset: () => void;
  handleComplete: () => Promise<void>;
  convertToConfirmPartsList: () => void;
};

const PartsSelectionFooter: React.FC<PartsSelectionFooterProps> = ({
  isSelectableParts,
  partsList,
  isShowOptionParts,
  setIsShowOptionParts,
  onClickBack,
  onClickReset,
  handleComplete,
  convertToConfirmPartsList,
}) => {
  const { t } = useTranslation();
  /** リセット確認ダイアログの開閉フラグ  */
  const [isOpenResetModal, setIsOpenResetModal] = useState(false);
  /** パーツ選択確認ダイアログの開閉フラグ  */
  const [isOpenConfirmModal, setIsOpenConfirmModal] = useState(false);

  /** 次へボタン押下時 */
  const onClickNext = async () => {
    // 選択可能なパーツが無い場合は確認ダイアログを出さない
    if (!isSelectableParts) {
      await handleComplete();
      return;
    }
    convertToConfirmPartsList();
    setIsOpenConfirmModal(true);
  };

  /** リセット確認ダイアログのOKボタン押下 */
  const onClickOkReset = () => {
    setIsOpenResetModal(false);
    onClickReset();
  };

  /** パーツ選択確認ダイアログのOKボタン押下 */
  const onClickOkConfirm = async () => {
    setIsOpenConfirmModal(false);
    await handleComplete();
  };

  return (
    <Box sx={{ flexGrow: 1, py: 2 }}>
      <Grid container spacing={2}>
        <Grid size={2}>
          <Button
            variant="outlined"
            fullWidth
            sx={{ justifyContent: 'center' }}
            onClick={onClickBack}
            startIcon={
              <ArrowBackIosSharpIcon
                style={{
                  verticalAlign: 'middle',
                  fontSize: '16px',
                }}
              />
            }
          >
            {t('BTN_BACK')}
          </Button>
        </Grid>
        <Grid size={0.5} />
        <Grid size={4}>
          {isSelectableParts && (
            <FormControlLabel
              control={
                <Checkbox
                  checked={isShowOptionParts}
                  onChange={() => setIsShowOptionParts(!isShowOptionParts)}
                />
              }
              label={t('LBL_OPTION_PARTS')}
            />
          )}
        </Grid>
        <Grid size={1.5} />
        <Grid size={2}>
          {isSelectableParts && (
            <Button
              variant="outlined"
              onClick={() => setIsOpenResetModal(true)}
              fullWidth
            >
              {t('BTN_RESET')}
            </Button>
          )}
        </Grid>
        <Grid size={2}>
          <Button
            variant="contained"
            fullWidth
            sx={{ justifyContent: 'center' }}
            endIcon={
              <ArrowForwardIosSharpIcon
                style={{
                  verticalAlign: 'middle',
                  fontSize: '16px',
                }}
              />
            }
            onClick={onClickNext}
          >
            {t('BTN_NEXT')}
          </Button>
        </Grid>
        <ConfirmModal
          isOpen={isOpenResetModal}
          displayMessage={t('MSG_CLEAR')}
          onClickCancel={() => setIsOpenResetModal(false)}
          onClickOk={onClickOkReset}
        />
        <ConfirmPartsModal
          isOpen={isOpenConfirmModal}
          onClickCancel={() => setIsOpenConfirmModal(false)}
          onClickOk={onClickOkConfirm}
          partsList={partsList}
        />
      </Grid>
    </Box>
  );
};

export default PartsSelectionFooter;
